import { render, staticRenderFns } from "./ContentQuote.vue?vue&type=template&id=1ba0af38&scoped=true&"
import script from "./ContentQuote.vue?vue&type=script&lang=js&"
export * from "./ContentQuote.vue?vue&type=script&lang=js&"
import style0 from "./ContentQuote.vue?vue&type=style&index=0&id=1ba0af38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba0af38",
  null
  
)

export default component.exports